import { Flex, Text } from '@chakra-ui/react';
import {
  Button,
  CarouselProvider,
  Grid,
  ReviewStars,
} from '@time-line/components/common';
import { useRatingsOverview } from 'hooks/reviews/useRatingsOverview';
import { REVIEWS } from 'lib/constants/routes';
import NextLink from 'next/link';
import type { WallOfLove as WallOfLoveProps } from 'types/cms/blocks/WallOfLove';

import { WallOfLoveCarousel } from './WallOfLoveCarousel';

export const CONTAINER_HEIGHT = 360;
export const INFO_BOX_HEIGHT = 20;

export const WallOfLove = ({ title, items }: WallOfLoveProps) => {
  const { data: ratings } = useRatingsOverview();

  return (
    <Grid
      className="section--wall-of-love"
      maxW="100%"
      justifyContent="center"
      alignItems="center"
      rowGap="lg"
      my="2xl"
    >
      <Flex
        gridColumn="main"
        width="100%"
        gap="3xs"
        direction={{ base: 'column', sm: 'row' }}
        alignItems="center"
        justifyContent="center"
      >
        {ratings?.ratingAverage && (
          <ReviewStars score={ratings.ratingAverage} />
        )}
        <Text as="h2" size="title3">
          {title}
        </Text>
      </Flex>
      <CarouselProvider>
        <WallOfLoveCarousel items={items} />
      </CarouselProvider>
      <Flex
        gridColumn="main"
        justifyContent={{ base: 'stretch', sm: 'center' }}
        width={{ base: '100%', sm: 'auto' }}
      >
        <Button
          as={NextLink}
          href={REVIEWS}
          variant="outline"
          isWide
          width={{ base: '100%', sm: 'auto' }}
        >
          Read all reviews
        </Button>
      </Flex>
    </Grid>
  );
};
